import { connect } from 'react-redux';
import { CreateButton } from '../components/index';

import { openResourceEditor } from '../actions';

const mapDispatchToProps = dispatch => (
  {
    createAction: () => {
      dispatch(openResourceEditor());
    },
  }
);

const CreateResource = connect(
  undefined,
  mapDispatchToProps,
)(CreateButton);

export default CreateResource;



// WEBPACK FOOTER //
// ./src/containers/CreateResource.js